import { Role } from "./user";
export var CustomerType;
(function (CustomerType) {
    CustomerType["PATIENT"] = "patient";
    CustomerType["OFFICE"] = "office";
    CustomerType["NURSE"] = "nurse";
})(CustomerType || (CustomerType = {}));
export var TransactionType;
(function (TransactionType) {
    /** Credit card authorization */
    TransactionType["AUTHORIZATION"] = "authorization";
    /** Credit card charge */
    TransactionType["CHARGE"] = "charge";
    /** Credit card failed charge */
    TransactionType["FAILED_CHARGE"] = "failedCharge";
    /** Credit card refund */
    TransactionType["REFUND"] = "refund";
    /** Add itinerary payment to wallet */
    TransactionType["ITINERARY_PAYMENT"] = "itineraryPayment";
    /** Add shift payment to wallet */
    TransactionType["SHIFT_PAYMENT"] = "shiftPayment";
    /** Add supply charge to wallet */
    TransactionType["SUPPLY_CHARGE"] = "supplyCharge";
    /** Payout funds from wallet, total must be negative */
    TransactionType["WITHDRAWAL"] = "withdrawal";
})(TransactionType || (TransactionType = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["COMPLETE"] = "complete";
})(TransactionStatus || (TransactionStatus = {}));
export const roleToCustomerType = (role) => {
    switch (role) {
        case (Role.NURSE):
            return CustomerType.NURSE;
        case (Role.PATIENT):
            return CustomerType.PATIENT;
        default:
            return CustomerType.OFFICE;
    }
};
export const isTransactionShiftPayment = (serviceData, transactionType) => {
    if (transactionType === TransactionType.SHIFT_PAYMENT)
        return true;
    return false;
};
export const isTransactionItineraryPayment = (serviceData, transactionType) => {
    if (transactionType === TransactionType.ITINERARY_PAYMENT)
        return true;
    return false;
};
//# sourceMappingURL=transaction.js.map